import PublicLayout from "sections/PublicLayout";
import PhotoGallery from "sections/public/PhotoGallery";
import { getResults } from "firestoreService";

function Results() {
  return (
    <PublicLayout
      eyebrow="A1 Institute"
      title="Results"
      subtitle="Students from our institute who cleared their exams with us."
    >
      <PhotoGallery
        fetchImages={getResults}
        alt="A1 Home Tutors student result"
        emptyText="No results have been published yet. Please check back soon."
      />
    </PublicLayout>
  );
}

export default Results;
